<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/k36IrA/tc-custom/9781429938679.jpg?1737763719819" alt="This image is the cover for the book Killer Kids, St. Martin's True Crime Classics"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Killer Kids, St. Martin's True Crime Classics
      </h1>
      <p class="bookDescription body article font2">
        <p>Innocent children turned ruthless murderers...Hate-filled and deeply disturbed...They kill with cold-blooded savagery...<br/><br/>Nothing was too good for precious Katy-- sports cars, jewelry, designer clothes. Her father, a successful South Florida businessman, could not resist any of her whims. But when he tried to curb her fast-lane lifestyle, she had him shot through the head while he slept.<br/><br/>Behind closed doors of her suburban Chicago home, Nancy Knuckles was a sadistic disciplinarian who, for years, terrorised her four children with religious fanaticism, beatings, and psychological torture, until they finally rebelled with a vengeance. After the oldest daughter strangled mom and stuffed her in a trunk, the kids partied hard, inviting their friends over for booze and rock 'n' roll.<br/><br/>Susan Cabot was a beautiful B-movie queen and obsessive mother. Her son Tim-- born a dwarf-- was pumped full of experimental drugs extracted from cadavers to increase his height. When the ex-film star's badly beaten body was discovered in her Hollywood home, little Timmy claimed she had been killed by men using Ninja methods-- before confessing.<br/><br/><i>Killer Kids </i>is Clifford L. Linedecker's shocking true crime book of children who turn to murder.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Clifford L. Linedecker
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7e319fe8